import { create } from 'zustand';
import type { Place, BBox } from '@wingman/shared';
import { DEFAULT_MAP_CENTER, DEFAULT_MAP_ZOOM } from '@wingman/shared';

export interface MapFilters {
  openNow: boolean;
  minRating: number;
  sortBy: 'distance' | 'rating' | 'name';
}

interface MapState {
  center: { lat: number; lng: number };
  zoom: number;
  bbox: BBox | null;
  places: Place[];
  selectedPlace: Place | null;
  loadingPlaces: boolean;
  activeCategory: string | null;
  filters: MapFilters;
  showFilters: boolean;
  setCenter: (lat: number, lng: number) => void;
  setZoom: (zoom: number) => void;
  setBBox: (bbox: BBox) => void;
  setPlaces: (places: Place[]) => void;
  setSelectedPlace: (place: Place | null) => void;
  setLoadingPlaces: (loading: boolean) => void;
  setActiveCategory: (category: string | null) => void;
  setFilters: (filters: Partial<MapFilters>) => void;
  toggleFilters: () => void;
}

export const useMapStore = create<MapState>((set) => ({
  center: DEFAULT_MAP_CENTER,
  zoom: DEFAULT_MAP_ZOOM,
  bbox: null,
  places: [],
  selectedPlace: null,
  loadingPlaces: false,
  activeCategory: null,
  filters: { openNow: false, minRating: 0, sortBy: 'distance' },
  showFilters: false,

  setCenter: (lat, lng) => set({ center: { lat, lng } }),
  setZoom: (zoom) => set({ zoom }),
  setBBox: (bbox) => set({ bbox }),
  setPlaces: (places) => set({ places }),
  setSelectedPlace: (place) => set({ selectedPlace: place }),
  setLoadingPlaces: (loading) => set({ loadingPlaces: loading }),
  setActiveCategory: (category) => set({ activeCategory: category }),
  setFilters: (filters) => set((state) => ({ filters: { ...state.filters, ...filters } })),
  toggleFilters: () => set((state) => ({ showFilters: !state.showFilters })),
}));
